"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSiteWorkCostForIdAndSurvey = exports.getFullGeneratedSiteWorkCosts = exports.getConfigurationSiteTotal = void 0;
const core_1 = require("@natomas-org/core");
const getConfigurationSiteTotal = (data, projectId, priceMode, configurationSite, opFraction, type) => {
    const rows = data
        .filter((row) => {
        return row[1].readOnly !== true;
    })
        .map((row) => {
        const [title, totalPrice, note] = row;
        const totalPriceInt = (0, core_1.getIntValue)(totalPrice.value);
        return {
            lineItemId: title.key,
            lineItemType: title.type,
            title: title.value,
            totalPrice: totalPrice.value,
            totalPriceInMicros: totalPriceInt * 100,
            note: note.value,
        };
    });
    let lineItems = [];
    const remainingLineItemsTypes = [];
    switch (type) {
        case core_1.BUDGET_SUMMARY_SECTION_TYPE.SITE_WORK_COSTPLUS:
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_PERMITS_COSTPLUS);
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_DESIGN_COSTPLUS);
            break;
        case core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_DESIGN_COSTPLUS:
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.SITE_WORK_COSTPLUS);
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_PERMITS_COSTPLUS);
            break;
        case core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_PERMITS_COSTPLUS:
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_DESIGN_COSTPLUS);
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.SITE_WORK_COSTPLUS);
            break;
        case core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_DTC:
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.SITE_WORK_DTC);
            break;
        case core_1.BUDGET_SUMMARY_SECTION_TYPE.SITE_WORK_DTC:
            remainingLineItemsTypes.push(core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_DTC);
            break;
        default:
            break;
    }
    if (configurationSite != null && configurationSite.lineItems != null) {
        remainingLineItemsTypes.forEach((lineItemType) => {
            lineItems = [
                ...lineItems,
                ...(0, core_1.getLineItemsFromConfigurationSite)(configurationSite, lineItemType),
            ];
        });
    }
    const rowsToAdd = rows.filter((row) => {
        // Remove empty rows
        return row.title !== "";
    });
    lineItems = lineItems.filter((lineItem) => {
        var _a;
        // Remove any rows with duplicate ids from before edits
        return !((_a = rowsToAdd.find((rowToAdd) => {
            return rowToAdd.lineItemId === lineItem.lineItemId;
        })) === null || _a === void 0 ? void 0 : _a.lineItemId);
    });
    const allLineItemsToSave = lineItems.concat(rowsToAdd);
    const opLineItems = allLineItemsToSave.filter((lineItem) => {
        return ((lineItem.lineItemId &&
            core_1.OP_LINE_ITEM_TYPES.includes(lineItem.lineItemId)) ||
            (lineItem.lineItemType &&
                core_1.OP_LINE_ITEM_TYPES.includes(lineItem.lineItemType)));
    });
    const toRemove = [];
    if (opLineItems.length > 0) {
        opLineItems.forEach((opLineItem) => {
            var _a, _b;
            const labelValueString = (_a = opLineItem === null || opLineItem === void 0 ? void 0 : opLineItem.title) === null || _a === void 0 ? void 0 : _a.toString();
            const match = labelValueString === null || labelValueString === void 0 ? void 0 : labelValueString.match(/\((\d+)%\)/);
            let labelValueNumber;
            if (match) {
                labelValueNumber = parseInt(match[1], 10);
            }
            const priceValueString = (_b = opLineItem === null || opLineItem === void 0 ? void 0 : opLineItem.totalPrice) === null || _b === void 0 ? void 0 : _b.toString();
            const priceValueNumber = (0, core_1.getIntValue)(priceValueString !== null && priceValueString !== void 0 ? priceValueString : "");
            if ((labelValueNumber && labelValueNumber > 0 && priceValueNumber > 0) ||
                labelValueNumber === priceValueNumber) {
                console.log("removing opLineItem: ", opLineItem);
            }
            else {
                toRemove.push(opLineItem);
            }
        });
    }
    const sanitizedAllLineItemsToSave = allLineItemsToSave.map((lineItem) => {
        var _a, _b, _c, _d;
        if (!toRemove.includes(lineItem)) {
            return lineItem;
        }
        else {
            const labelValueString = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.title) === null || _a === void 0 ? void 0 : _a.toString();
            const labelValueNumber = (0, core_1.getIntValue)((_b = labelValueString === null || labelValueString === void 0 ? void 0 : labelValueString.slice((labelValueString === null || labelValueString === void 0 ? void 0 : labelValueString.length) - 4, (labelValueString === null || labelValueString === void 0 ? void 0 : labelValueString.length) - 1)) !== null && _b !== void 0 ? _b : "");
            let liType;
            switch ((_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineItemType) !== null && _c !== void 0 ? _c : lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineItemId) {
                case core_1.LineItemType.OP_PRECON_DESIGN:
                    liType = core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_DESIGN_COSTPLUS;
                    break;
                case core_1.LineItemType.OP_PRECON_PERMITS:
                    liType = core_1.BUDGET_SUMMARY_SECTION_TYPE.PRE_CON_PERMITS_COSTPLUS;
                    break;
                case core_1.LineItemType.OP_HOME_DESIGN:
                    liType = core_1.BUDGET_SUMMARY_SECTION_TYPE.HOME_DESIGN_COSTPLUS;
                    break;
                case core_1.LineItemType.OP_SITE_WORK:
                    liType = core_1.BUDGET_SUMMARY_SECTION_TYPE.SITE_WORK_COSTPLUS;
                    break;
            }
            let newOpMicros = 0;
            if (liType) {
                let totalMicros = 0;
                (0, core_1.getLineItemsForType)(allLineItemsToSave, liType).forEach((item) => {
                    var _a, _b, _c;
                    if (!core_1.OP_LINE_ITEM_TYPES.includes(((_b = (_a = item === null || item === void 0 ? void 0 : item.lineItemType) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.lineItemId) !== null && _b !== void 0 ? _b : ""))) {
                        totalMicros += (_c = item === null || item === void 0 ? void 0 : item.totalPriceInMicros) !== null && _c !== void 0 ? _c : 0;
                    }
                });
                const newOpFraction = opFraction !== null && opFraction !== void 0 ? opFraction : labelValueNumber / 100;
                newOpMicros = Math.round((totalMicros * newOpFraction) / 100) * 100;
                if (opFraction === labelValueNumber / 100) {
                    return;
                }
            }
            return Object.assign({}, lineItem, {
                basePrice: newOpMicros / 100,
                lineItemType: (_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineItemId) !== null && _d !== void 0 ? _d : lineItem === null || lineItem === void 0 ? void 0 : lineItem.lineItemType,
                totalPrice: newOpMicros / 100,
                totalPriceInMicros: newOpMicros,
            });
        }
    });
    const pricePayloadInfo = getPhase1AndSiteWorkSumMicrosFromAllLineItems(sanitizedAllLineItemsToSave.filter((val) => {
        return val !== undefined;
    }), priceMode);
    const payload = Object.assign(Object.assign({ lineItems: sanitizedAllLineItemsToSave }, pricePayloadInfo), { autoGeneratedQuote: false });
    return payload;
};
exports.getConfigurationSiteTotal = getConfigurationSiteTotal;
function getPhase1AndSiteWorkSumMicrosFromAllLineItems(lineItems, priceMode) {
    let totalPhase1DesignCostMicros = 0;
    let totalPhase1PermitCostMicros = 0;
    let totalSiteWorkCostInMicros = 0;
    let totalPhase1CostInMicros = 0;
    const isCostPlus = priceMode === core_1.ProjectPriceMode.CostPlus;
    lineItems.forEach((lineItem) => {
        switch (lineItem.lineItemType) {
            case core_1.LineItemType.EXTERIOR_FINISHING_LINE_ITEM_ID:
            case core_1.LineItemType.INTERIOR_FINISHING_LINE_ITEM_ID:
            case core_1.LineItemType.POWER_LINE_ITEM_ID:
            case core_1.LineItemType.SEWER_LINE_ITEM_ID:
            case core_1.LineItemType.DELIVERY_LINE_ITEM_ID:
            case core_1.LineItemType.FOUNDATION_LINE_ITEM_ID:
            case core_1.LineItemType.WATER_LINE_ITEM_ID:
            case core_1.LineItemType.SITE_SERVICES_LINE_ITEM_ID:
            case core_1.LineItemType.INSTALLATION_LINE_ITEM_ID:
            case core_1.LineItemType.CONSTRUCTION_MANAGEMENT_FEE_LINE_ITEM_ID:
                // eslint-disable-next-line no-case-declarations
                let microsToAdd = lineItem.totalPriceInMicros;
                if (!microsToAdd && lineItem.totalPrice) {
                    microsToAdd = (0, core_1.getIntValue)(lineItem.totalPrice) * 100;
                }
                if (lineItem.lineItemType ===
                    core_1.LineItemType.CONSTRUCTION_MANAGEMENT_FEE_LINE_ITEM_ID &&
                    isCostPlus) {
                    break;
                }
                totalSiteWorkCostInMicros += microsToAdd !== null && microsToAdd !== void 0 ? microsToAdd : 0;
                break;
            case core_1.LineItemType.PHASE_1_LINE_ITEM_ID:
            case core_1.LineItemType.CONSULTANTS_LINE_ITEM_ID:
            case core_1.LineItemType.PERMIT_LINE_ITEM_ID:
            case core_1.LineItemType.ENG_AND_DESIGN_LINE_ITEM_ID:
                // eslint-disable-next-line no-case-declarations
                let phase1MicrosToAdd = lineItem.totalPriceInMicros;
                if (!phase1MicrosToAdd && lineItem.totalPrice) {
                    phase1MicrosToAdd = (0, core_1.getIntValue)(lineItem.totalPrice) * 100;
                }
                if (isCostPlus) {
                    if (lineItem.lineItemType === core_1.LineItemType.PERMIT_LINE_ITEM_ID) {
                        totalPhase1PermitCostMicros += phase1MicrosToAdd !== null && phase1MicrosToAdd !== void 0 ? phase1MicrosToAdd : 0;
                        break;
                    }
                    else {
                        totalPhase1DesignCostMicros += phase1MicrosToAdd !== null && phase1MicrosToAdd !== void 0 ? phase1MicrosToAdd : 0;
                        break;
                    }
                }
                else {
                    totalPhase1CostInMicros += phase1MicrosToAdd !== null && phase1MicrosToAdd !== void 0 ? phase1MicrosToAdd : 0;
                    break;
                }
            case core_1.LineItemType.OP_PRECON_DESIGN:
            case core_1.LineItemType.OP_PRECON_PERMITS:
            case core_1.LineItemType.OP_SITE_WORK:
                if (isCostPlus) {
                    let microsToAdd = lineItem.totalPriceInMicros;
                    if (!microsToAdd && lineItem.totalPrice) {
                        microsToAdd = (0, core_1.getIntValue)(lineItem.totalPrice) * 100;
                    }
                    switch (lineItem.lineItemType) {
                        case core_1.LineItemType.OP_PRECON_DESIGN:
                            totalPhase1DesignCostMicros += microsToAdd !== null && microsToAdd !== void 0 ? microsToAdd : 0;
                            break;
                        case core_1.LineItemType.OP_PRECON_PERMITS:
                            totalPhase1PermitCostMicros += microsToAdd !== null && microsToAdd !== void 0 ? microsToAdd : 0;
                            break;
                        case core_1.LineItemType.OP_SITE_WORK:
                            totalSiteWorkCostInMicros += microsToAdd !== null && microsToAdd !== void 0 ? microsToAdd : 0;
                            break;
                    }
                }
                break;
            case core_1.LineItemType.OTHER_LINE_ITEM_ID:
                break;
        }
    });
    if (isCostPlus) {
        totalPhase1CostInMicros =
            totalPhase1PermitCostMicros + totalPhase1DesignCostMicros;
    }
    return {
        totalPhase1CostInMicros,
        totalPhase1DesignCostMicros,
        totalPhase1PermitCostMicros,
        totalSiteWorkCostInMicros,
    };
}
// This logic exists in multiple parts of the app and needs to be centralized
const getFullGeneratedSiteWorkCosts = async (product, surveyAnswers, jurisdictionData) => {
    var _a, _b, _c, _d;
    const productSiteWorkCosts = product === null || product === void 0 ? void 0 : product.default_site_work_costs;
    const lineItemArray = core_1.SITE_WORK_AND_PRE_CON_LINE_ITEMS.map((siteWorkLineItem) => {
        return (0, exports.getSiteWorkCostForIdAndSurvey)(productSiteWorkCosts, siteWorkLineItem, surveyAnswers);
    }).filter((lineItem) => lineItem.totalPriceInMicros !== 0);
    let totalSiteWorkInMicros = 0;
    lineItemArray.forEach((lineItem) => {
        if (lineItem.totalPriceInMicros) {
            totalSiteWorkInMicros += lineItem.totalPriceInMicros;
        }
    });
    const approvalRequirements = (_b = (_a = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.requirements) === null || _a === void 0 ? void 0 : _a.approvalReqs) !== null && _b !== void 0 ? _b : [];
    const submittalRequirements = (_d = (_c = jurisdictionData === null || jurisdictionData === void 0 ? void 0 : jurisdictionData.requirements) === null || _c === void 0 ? void 0 : _c.submittalReqs) !== null && _d !== void 0 ? _d : [];
    // TODO B2B June 14, '22: Thomas wants all instant quotes to include a boundary survey.
    const filteredRequirements = [
        ...approvalRequirements,
        ...submittalRequirements,
    ].filter((e) => e !== "SURVEY"); // Remove the boundary in case of duplicates
    const phase1LineItems = [];
    let totalPhase1RequirementsCost = 0;
    const requirementArray = [...filteredRequirements, "SURVEY"];
    if (requirementArray) {
        // Add the boundary survey to all projects
        requirementArray.forEach((item) => {
            var _a, _b;
            const contents = core_1.REQUIREMENTS[item];
            if (contents) {
                const cost = ((_a = contents.totalPriceInMicros) !== null && _a !== void 0 ? _a : 0) * core_1.MARGIN_MULTIPLIER;
                totalPhase1RequirementsCost += cost;
                phase1LineItems.push({
                    lineItemType: contents.lineItemType,
                    lineItemId: ((_b = contents.lineItemId) !== null && _b !== void 0 ? _b : core_1.LineItemType.CONSULTANTS_LINE_ITEM_ID) +
                        phase1LineItems.length,
                    note: contents.note,
                    title: contents.title,
                    totalPriceInMicros: cost,
                });
            }
        });
    }
    return {
        autoGeneratedQuote: true,
        lineItems: [...lineItemArray, ...phase1LineItems],
        totalSiteWorkCostInMicros: totalSiteWorkInMicros + totalPhase1RequirementsCost,
        surveyAnswers: surveyAnswers,
    };
};
exports.getFullGeneratedSiteWorkCosts = getFullGeneratedSiteWorkCosts;
const getSiteWorkCostForIdAndSurvey = (productInfo, lineItem, survey) => {
    var _a;
    let initialValue = lineItem === null || lineItem === void 0 ? void 0 : lineItem.basePriceInMicros;
    if (productInfo && !lineItem.isDominantOverProductSiteWork) {
        const foundProductSiteWorkItem = productInfo.find((item) => {
            return item.id === lineItem.lineItemId;
        });
        if (foundProductSiteWorkItem === null || foundProductSiteWorkItem === void 0 ? void 0 : foundProductSiteWorkItem.basePriceMicros) {
            initialValue = foundProductSiteWorkItem.basePriceMicros;
        }
    }
    let valueToReturn = (initialValue !== null && initialValue !== void 0 ? initialValue : 0) * core_1.MARGIN_MULTIPLIER;
    let note = "";
    switch (lineItem.lineItemId) {
        case core_1.LineItemType.SITE_PREP_LINE_ITEM_ID: {
            const slopeCost = (survey.slope === "Mild"
                ? core_1.AdditionalCosts.slopeMild
                : core_1.AdditionalCosts.slopeFlat) * core_1.MARGIN_MULTIPLIER;
            valueToReturn += slopeCost;
            note = `${survey.slope} slope: $${(0, core_1.getTextFromPriceMicros)(slopeCost)}; `;
            (_a = survey.structures) === null || _a === void 0 ? void 0 : _a.forEach((structure) => {
                var _a;
                const structureCost = core_1.Structures[structure];
                if (structureCost) {
                    const cost = ((_a = structureCost === null || structureCost === void 0 ? void 0 : structureCost.totalPriceInMicros) !== null && _a !== void 0 ? _a : 0) * core_1.MARGIN_MULTIPLIER;
                    valueToReturn += cost;
                    note += `${structureCost.title}: +$${(0, core_1.getTextFromPriceMicros)(cost)}; `;
                }
            });
            break;
        }
        case core_1.LineItemType.DELIVERY_LINE_ITEM_ID: {
            if (survey.crane === "yes") {
                const craneCost = core_1.AdditionalCosts.crane * core_1.MARGIN_MULTIPLIER;
                valueToReturn += craneCost;
                note += `Crane: +$${(0, core_1.getTextFromPriceMicros)(craneCost)}`;
            }
            break;
        }
    }
    return {
        lineItemType: lineItem.lineItemType,
        lineItemId: lineItem.lineItemId,
        title: lineItem.title,
        totalPriceInMicros: valueToReturn,
        note: note === "" && lineItem.note ? lineItem.note : note,
    };
};
exports.getSiteWorkCostForIdAndSurvey = getSiteWorkCostForIdAndSurvey;
//# sourceMappingURL=index.js.map